"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CustomReason {
}
exports.default = CustomReason;
//# sourceMappingURL=CustomReason.js.map